<template>
	<div>
		<button class="yellow-button" type="button" @click="$emit('submit-add-item')">
			<span class="yellow-button-text">
				{{ text }}
			</span>
			<icon-base v-if="showIcon" width="18" height="23" :iconName="'Add to My Order'">
				<icon-bag />
			</icon-base>
		</button>
	</div>
</template>

<script>
import IconBase from "../IconBase.vue";
import IconBag from "../icons/IconBag.vue";

export default {
	name: "YellowButton",
	components: {
		IconBase,
		IconBag,
	},
	props: {
		showIcon: {
			type: Boolean,
			default: true,
		},
		text: String,
	},
};
</script>

<style lang="scss" scoped>
.yellow-button {
	@include transition(background-color, transform);
	font-size: 1.8rem;
	font-weight: 900;
	padding: 11px;
	margin-top: 10px;
	background-color: $gold;
	border-radius: 22.5px;
	box-shadow: $box-shadow;
	display: flex;
	align-items: center;

	&:hover,
	&:focus {
		transform: translate(0, -2px);
		background-color: $royal;
	}
}

.yellow-button-text {
	line-height: 1;
	margin: 0 5px;
}
</style>